<section class="container">
  <ul class="breadcrumb" *ngIf="breadcrumbs?.length > 0">
    <li
      *ngFor="let breadcrumb of breadcrumbs"
      class="breadcrumb-item font-small light"
    >
      <a
        (click)="navigateTo(breadcrumb)"
        [ngClass]="{ active: !!breadcrumb.url }"
      >
        {{ breadcrumb.label }}
      </a>
    </li>
  </ul>
</section>
